const STORAGE_KEY = "taskratel:notification-volume";

export const getNotificationVolume = (): number => {
  if (typeof window === "undefined") return 0.6;
  const raw = window.localStorage.getItem(STORAGE_KEY);
  const parsed = raw === null ? NaN : parseFloat(raw);
  if (Number.isNaN(parsed)) return 0.6;
  return Math.min(1, Math.max(0, parsed));
};

export const setNotificationVolume = (volume: number) => {
  const clamped = Math.min(1, Math.max(0, volume));
  window.localStorage.setItem(STORAGE_KEY, String(clamped));
  window.dispatchEvent(new CustomEvent("taskratel:volume-change", { detail: clamped }));
};

let audioCtx: AudioContext | null = null;

/** Plays a short two-tone chime using the Web Audio API (no asset needed). */
export const playNotificationSound = (volumeOverride?: number) => {
  const volume = volumeOverride ?? getNotificationVolume();
  if (volume <= 0) return;

  try {
    const Ctx = window.AudioContext || (window as any).webkitAudioContext;
    if (!Ctx) return;
    if (!audioCtx) audioCtx = new Ctx();
    if (audioCtx.state === "suspended") void audioCtx.resume();

    const now = audioCtx.currentTime;
    [
      { freq: 880, start: 0 },
      { freq: 1174.7, start: 0.13 },
    ].forEach(({ freq, start }) => {
      const osc = audioCtx!.createOscillator();
      const gain = audioCtx!.createGain();
      osc.type = "sine";
      osc.frequency.value = freq;
      gain.gain.setValueAtTime(0.0001, now + start);
      gain.gain.exponentialRampToValueAtTime(Math.max(0.0002, volume * 0.35), now + start + 0.02);
      gain.gain.exponentialRampToValueAtTime(0.0001, now + start + 0.22);
      osc.connect(gain).connect(audioCtx!.destination);
      osc.start(now + start);
      osc.stop(now + start + 0.25);
    });
  } catch (error) {
    console.warn("Notification sound unavailable:", error);
  }
};
